import axios from "axios";
import config from "../config";
import { getDoctorToken } from "../utils"

const saveAppointmentReportApi = async (params) => {
  const response = await axios({
    url: `${config.api.base_url}report/upload`,
    method: "post",
    data: params,
    headers: {
      "Content-Type": "application/json",
      "Authorization": `Bearer ${getDoctorToken()}`
    },
  });

  return response;
};

export default saveAppointmentReportApi;
